/* eslint-disable react/prop-types */
import { parseParamValue } from '@rcg/query-parser';
import { SORT_OPTIONS } from '@rcg/query-parser/dist/constants';
import { getUserFavorite, getUserWatchlistItems } from '@rcg/ui-user';
import { getFavoritesConfig } from 'components/CruiseCard/CruiseCardUserFavoriteButton/CruiseCardUserFavoriteButton.utils';
import { reduceCruise } from 'contexts/Search';
// eslint-disable-next-line import/no-unresolved
import { EVENT_CRUISE_SEARCH_APPLY_FILTERS } from 'components/CruiseDetailsPanel/CruiseDetailsPanel.constants';
import { getParamFromNL } from 'components/NLSearch/utils';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import countryList from 'lib/api/queries/data/countryList';
import { getDictionary } from 'lib/api/queries/dictionary/getDictionary';
import { SERVER_TOGGLES } from 'lib/constants';
import getFeaturedImage from 'lib/cruise/itinerary/getFeaturedImage';
import getImagePool from 'lib/cruise/itinerary/getImagePool';
import { getCabinDictionary } from 'lib/cruise/sailings';
import { localeDateMap } from 'lib/format';
import { filterDictionary } from 'lib/globalization/Dictionary';
import { getBestPromoForMarket } from 'lib/graphql/campaigns/campaigns.client';
import { getFacetOptions, getFilterResults, getSailingsByCruise } from 'lib/graphql/cruises/cruises.client';
import { getAllCountries } from 'lib/graphql/globalization/globalization.client';
import { includes, keyBy } from 'lib/helpers';
import { getPromotionsState, mapFaceting, mergeQuerys } from 'lib/promotions';
import { updateCruiseStateroomClassPricing } from 'lib/utilities/updateCruiseStateroomClassPricing';
import _cloneDeep from 'lodash/cloneDeep';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';
import {
	ADULTS,
	ADULTS_DEFAULT,
	ANALYTICS,
	BRANDS,
	CABIN_CLASS,
	CHILDREN,
	CHILDREN_DEFAULT,
	COMPARE_PAGE,
	COUPON,
	CRUISES_COMPARE_PAGE,
	EMAIL_ID,
	EVENT_CLEAN_WIDGET_FILTERS,
	EVENT_SEARCH_RESULTS_READY,
	FACET,
	GROUP_ID,
	HOME_PAGE_QUERY_PARAM,
	LOYALTY_ID,
	MAX_MEDALLIA_SDK_CHECK_ATTEMPTS,
	MULTI_QUERY_PARAM_DIVIDER,
	NLS_PARAM,
	NUMBER_OF_GUESTS,
	POPUP,
	PROMO,
	QUALIFIERS,
	QUERY_PARAM_DIVIDER,
	SEARCH,
	SORT,
	SORT_BY_PRICE,
	SORT_ORDER_ASC,
	START_DATE,
	TARGETED_OFFER_APPLIED,
	blankResults,
	searchDefault,
} from './constants';
import labels from './labels.json';
import { dispatchCustomEvent } from './utils/customEvent';
import {
	addFilterQueryParamsObject,
	makeParamsObjectFromRouteQuery,
	makeRouteQueryFromStore,
	makeSortVariable,
	makeStoreFromRouteQuery,
	removeFilterQueryParamsObject,
	urlParamsToObject,
} from './utils/filterParser';
import { getPortCodes, getPorts } from './utils/formatPorts';
import { getMetadataImage, getMetadataValues } from './utils/metadataUtils';
import { parseQualifiers } from './utils/parseQualifiers';
import { sortTargetedOffers } from './utils/targetedOffers';
import {
	getObjectFromQuery,
	getUniqueDestinationAndParamsUtil,
	getUniqueDestinationsStateUtil,
	updatedUniqueDestinationsUtil,
	validateIsUniqueDestination,
} from './utils/uniqueDestinationsUtils';

export const CruiseSearchContext = React.createContext({});

// const sortDefault = [{ by: 'PRICE', order: 'ASC' }];

const matchMarket = /\[market\]/;
const matchLanguage = /\[language\]/;

const count = 10;

/**
 * Holds the state for filtering, routing logic, and search results
 */
class CruiseSearchContextProvider extends React.Component {
	constructor(props) {
		super(props);

		const {
			alerts,
			searchApplied = searchDefault,
			searchSelecting = searchDefault,
			filterOptions,
			filterOptionsDictionary,
			dateRangeCalendar,
			monthsCalendar,
			daysOfWeek,
			metadata,
			ssrFlags,
			ssrCommonFlags,
			queryStringParsed,
			brand,
			locale,
			dictionaries,
			universalNavigationContent,
			promotions,
			logId,
		} = props?.initialState || {};

		const fullBrandSettings = BRANDS.find((b) => b.code === brand);

		const market = locale?.market,
			language = locale?.language;

		if (process.browser) {
			const localeKey = `${(market || '').toLowerCase()}_${(language || '').toLowerCase()}`;
			window.localeId = localeDateMap[localeKey]?.id || 'enUS';
		}

		this.state = {
			alerts,
			filterOpen: '',
			filterMode: '',
			filterOptions,
			filterOptionsDictionary,
			filterChange: false,
			facetOptions: {},

			dateRangeCalendar,
			monthsCalendar,
			daysOfWeek,

			searchApplied,
			nlUserQuery: '',
			searchSelecting,
			monthsSelecting: searchSelecting,
			datesSelecting: searchSelecting,

			monthsApplied: searchApplied,
			datesApplied: searchApplied,
			sortApplied: [],

			qualifiersApplied: [],
			qualifiersSelecting: [],

			uniqueDestinationsAvailable: [],
			uniqueDestinations: [],
			additionalParamsApplied: null,
			otherParamsApplied: null,

			pagination: {
				skip: 0,
				count,
				currentPage: 0,
			},

			loading: true,
			results: blankResults,
			resultsValidated: false,

			language,
			market,
			labels,
			locale,

			promo: {},
			loadedPromo: false,

			toogles: {},
			ssrFlags,
			ssrCommonFlags,

			metadata,
			universalNavigation: universalNavigationContent,
			userFavorites: [],
			userWatchlist: [],
			promotions,
			promotionsApplied: {},
			promotionSelected: null,
			promotionApplied: null,
			loadingPromotions: false,
			querySearch: undefined,

			openFilters: this.openFilters,
			closeFilters: this.closeFilters,

			fetchSearchResults: this.fetchSearchResults,
			fetchMoreSearchResults: this.fetchMoreSearchResults,

			applyFilters: this.applyFilters,

			fetchAndUpdateFacetOptions: this.fetchAndUpdateFacetOptions,

			updateSearchSelectingFilter: this.updateSearchSelectingFilter,
			updateSearchSelecting: this.updateSearchSelecting,
			updateMonthsSelectingFilter: this.updateMonthsSelectingFilter,
			updateDatesSelectingFilter: this.updateDatesSelectingFilter,
			addToSearchSelectingFilter: this.addToSearchSelectingFilter,
			removeFromSearchSelectingFilter: this.removeFromSearchSelectingFilter,
			removeAdditionalFilters: this.removeAdditionalFilters,
			resetSearchSelecting: this.resetSearchSelecting,
			resetSearchSelectingFilter: this.resetSearchSelectingFilter,
			resetSearchSelectingToSearchApplied: this.resetSearchSelectingToSearchApplied,
			resetAllFilters: this.resetAllFilters,
			resetQueryParamsObject: this.resetQueryParamsObject,

			updateSortApplied: this.updateSortApplied,

			updateQualifiersSelecting: this.updateQualifiersSelecting,
			addToQualifiersSelecting: this.addToQualifiersSelecting,
			removeFromQualifiersSelecting: this.removeFromQualifiersSelecting,
			removeParamFromOtherParams: this.removeParamFromOtherParams,

			resetSearchResults: this.resetSearchResults,
			replaceSearchResultsCruises: this.replaceSearchResultsCruises,
			removeAllFilters: this.removeAllFilters,

			removeTargetedOfferApplied: this.removeTargetedOfferApplied,

			removeQualifierApplied: this.removeQualifierApplied,
			updateOtherParamsString: this.updateOtherParamsString,
			udpateSelectedCurrency: this.udpateSelectedCurrency,
			selectGroupIdDetail: this.selectGroupIdDetail,
			getSailingsByCruise: this.getSailingsByCruise,
			openModal: this.openModal,
			closeModal: this.closeModal,
			loadDictionary: this.loadDictionary,
			toogleLoader: this.toogleLoader,

			resetSoldOut: this.resetSoldOut,
			setIsInvalidEmailOrCASId: this.setIsInvalidEmailOrCASId,
			updateLoyaltyIDOrEmailLogin: this.updateLoyaltyIDOrEmailLogin,
			getCountries: this.getCountries,
			setAppliedDateFilter: this.setAppliedDateFilter,

			updateWatchlistResults: this.updateWatchlistResults,
			getFavoritesList: this.getFavoritesList,
			getWatchlistList: this.getWatchlistList,
			updateStatusQueryChange: this.updateStatusQueryChange,
			updateFilterChange: this.updateFilterChange,
			updateInitialTrackPageEvent: this.updateInitialTrackPageEvent,

			openModalByUrl: this.openModalByUrl,
			getModalByUrl: this.getModalByUrl,

			getUniqueDestinationsState: this.getUniqueDestinationsState,
			updatedUniqueDestinations: this.updatedUniqueDestinations,
			getState: this.getState,
			updateState: this.updateState,

			removeAppliedPromotion: this.removeAppliedPromotion,
			setPromotionSelected: this.setPromotionSelected,
			setPromotionApplied: this.setPromotionApplied,
			setPromotions: this.setPromotions,
			getStatePromotions: this.getStatePromotions,
			updateAdditionalFilters: this.updateAdditionalFilters,

			modalByUrlOpen: false,

			imagePool: null,
			initialTrackPageEvent: false,
			portAdded: false,
			portCodes: [],
			itineraryPanel: '',

			targetedOffers: [],
			targetedOffersSorted: [],
			targetedOffersLoaded: false,
			targetedOffersLoading: false,
			targetedOfferApplied: {},
			targetedOfferSelected: {},
			targetedOffersDisabledMessage: {},
			targetedOfferBannerSoldOut: false,
			targetedOfferIsValidPromo: true,
			targetedofferUrlValidateMatch: false,
			errorTargetedOffers: {
				code: null,
				isNetWorkError: false,
			},
			errorTargetedOfferMessage: '',
			isInvalidEmailOrCASId: false,
			targetedOffersPillShow: false,
			targetedOffersPillClosed: false,
			targetedOffersLogged: false,
			targetedFilters: {},
			loyaltyIDOrEmailLogin: '',
			targetedOffersQuery: {},
			modalOpen: '',
			loginOrigin: '',
			countries: countryList,
			showLoading: false,
			appliedDateFilter: START_DATE,
			lastTOActive: {
				couponCode: '',
				timeStamp: '',
			},
			queryStringParsed,
			queryParamsObject: {},
			queryParamsObjectApplied: {},
			defaultSorting: undefined,
			logId,
			brand,
			queryChanged: false,
			initialUpdate: false,
			...this.getStateGlobalization(dictionaries),
			fullBrandSettings: fullBrandSettings,
			nlsValue: '',
			nlsPerformed: false,
			updateNls: this.updateNls,
			currentNls: null,
			updateCurrentNls: this.updateCurrentNls,
			nlsInput: '',
			updateNlsInput: this.updateNlsInput,
			...this.getStateNaturalLanguage(),
		};
	}

	componentDidMount() {
		/**
		 * Need country, currency, language to query
		 * hard-coding for now but this may need to move
		 * from mount after sorting out localization
		 */
		const query = urlParamsToObject(this.state.queryStringParsed);
		this.setState({
			itineraryPanel: query.itineraryPanel ?? '',
		});
		const { initialState, flags } = this.props;
		const showQualifer = !!initialState?.ssrFlags[SERVER_TOGGLES.SHOW_TARGETED_OFFERS_PERKS_QUALIFIERS];

		const hasOccupancyQueryParams = query[SEARCH]?.includes(ADULTS) || query[SEARCH]?.includes(CHILDREN);
		const hasOccupancyLocalStorage = localStorage.getItem(NUMBER_OF_GUESTS.key);

		if (hasOccupancyLocalStorage && (!hasOccupancyQueryParams || hasOccupancyQueryParams === undefined)) {
			query[SEARCH] = this.addOccupancyFromStorage(hasOccupancyLocalStorage, query);
			this.updateStoreFromQuery(query, {}, this.applyFilters);
		}

		if (initialState.ssrFlags[SERVER_TOGGLES.SHOW_PROMOTION_BANNER]) {
			this.fetchBestPromoForMarket(showQualifer);
		}
		let { search } = makeStoreFromRouteQuery(query);

		this.updateMonthsSelectingFilter([START_DATE], search[START_DATE]);
		this.updateStoreFromQuery(query, {});
		const { router = {} } = this.props;
		const { promo } = router.query;
		if (promo) {
			const promoToCheck = Array.isArray(promo) ? promo[0] : promo;
			const promoQuery = `${PROMO}=${promo}`;
			this.setPromotionSelected(promo);
			this.updateAdditionalFilters(promoQuery);

			this.getStatePromotions({ displayQualifier: showQualifer, promo: promoToCheck }, (promoToSet, promotions) => {
				this.updateDataPromotions(promoToSet, promotions, query);
			});
		} else {
			const enableRecommendedSortOption =
				flags.enableRecommendedSortOption ||
				flags.enablePercentageRolloutCampaign?.toggles?.enableRecommendedSortOption ||
				initialState.ssrFlags[SERVER_TOGGLES.ENABLE_RECOMMENDED_SORT_OPTION] ||
				false;
			const enableDefaultSortOption =
				flags.enableDefaultSortOption ||
				flags.enablePercentageRolloutCampaign?.toggles?.enableDefaultSortOption ||
				initialState.ssrFlags[SERVER_TOGGLES.ENABLE_DEFAULT_SORT_OPTION] ||
				'PRICE_LOW_TO_HIGH';
			const enableRiverCruises =
				flags.enableRiverCruises ||
				flags.enablePercentageRolloutCampaign?.toggles?.enableRiverCruises ||
				initialState.ssrFlags[SERVER_TOGGLES.ENABLE_RIVER_CRUISES] ||
				false;

			this.fetchSearchResults(
				query,
				true,
				{},
				{
					enableDefaultSortOption,
					enableRecommendedSortOption,
					enableRiverCruises,
				},
			);
		}
		let attempts = 0;
		const onTimer = () => {
			if (window.KAMPYLE_ONSITE_SDK) {
				window.KAMPYLE_ONSITE_SDK.rcgUpdatePageView = window.KAMPYLE_ONSITE_SDK.updatePageView;
				// this is to prevent the Medallia SDK from reloading the surveys on each URL change
				window.KAMPYLE_ONSITE_SDK.updatePageView = () => null;
				clearInterval(medalliaSdkCheck);
			}
			attempts++;
			if (attempts >= MAX_MEDALLIA_SDK_CHECK_ATTEMPTS) {
				clearInterval(medalliaSdkCheck);
			}
		};
		const medalliaSdkCheck = setInterval(onTimer, 1000);
	}

	componentDidUpdate(prevProps, prevState) {
		const overridesFlags = this.props.flags.enablePercentageRolloutCampaign?.toggles || {}; // Can be null
		const updatedFlags = {
			...this.props.flags,
			...overridesFlags,
		};

		let enableEmailOnTargetedOffers;

		const prevQuery = prevProps.router?.query || {};
		let { query = {} } = this.props.router || {};
		delete prevQuery[GROUP_ID];
		delete query[GROUP_ID];

		const { search } = makeStoreFromRouteQuery(query);

		const hasDefaultSortingBy = !!this.state.defaultSorting?.by;
		const hasInitialDefaultSortUpdated = hasDefaultSortingBy
			? !updatedFlags?.enableDefaultSortOption.includes(this.state.defaultSorting?.by)
			: this.props.initialState.ssrFlags[SERVER_TOGGLES.ENABLE_DEFAULT_SORT_OPTION] !== updatedFlags?.enableDefaultSortOption;

		if (!this.state.initialUpdate && hasInitialDefaultSortUpdated && updatedFlags.enableDefaultSortOption && !this.state.loading) {
			if (this.nlsIsFinished()) {
				this.fetchSearchResults(query, true, prevState, updatedFlags);
			}
			let { sort } = makeStoreFromRouteQuery(query);

			this.setState(
				{
					initialUpdate: true,
					sortApplied: sort,
					defaultSorting: this.getDefaultSorting(updatedFlags),
				},
				() => sort.length && this.applyFilters(),
			);
		}

		if (this.nlsIsFinished()) {
			if (!this.props.flags.enableGraphNlSearch) {
				delete prevQuery[NLS_PARAM];
			}

			const queryChanged = JSON.stringify(prevQuery) !== JSON.stringify(query);
			const { promotionApplied, promotionSelected } = this.state;
			this.validatePromotion(prevState, updatedFlags);

			if (queryChanged) {
				const { promo = null } = query;
				const isNewCallPromotions = promotionApplied !== promo && promotionSelected !== promo;
				const showQualifier = this.state.toogles?.showTargetedOffersPerksQualifier;

				if (isNewCallPromotions && !!promo) {
					const promoToCheck = Array.isArray(promo) ? promo[0] : promo;
					this.setPromotionSelected(promo);
					this.getStatePromotions({ displayQualifier: showQualifier, promo: promoToCheck }, (promoToSet, promotions) => {
						this.updateDataPromotions(promoToSet, promotions, query);
					});
				}

				this.fetchAndUpdateFacetOptions();
				if (!this.state.datesSelecting[START_DATE]?.length) {
					this.updateMonthsSelectingFilter([START_DATE], search[START_DATE]);
				}
				if (query) {
					this.updatedUniqueDestinations();
				}

				this.updateStoreFromQuery(query, updatedFlags);
				const { loadingPromotions } = this.state;

				if (!loadingPromotions) {
					this.fetchSearchResults(query, true, prevState, updatedFlags);
				}
				this.setState({ queryChanged });
			}
		}

		const language = this.props.router?.query?.language;
		const market = this.props.router?.query?.market;

		const languageChanged = !!language && language !== prevProps.router?.query?.language;
		const marketChanged = !!market && market !== prevProps.router?.query?.market;

		if (marketChanged || languageChanged) {
			if (process.browser) {
				const localeKey = `${(market || '').toLowerCase()}_${(language || '').toLowerCase()}`;
				window.localeId = localeDateMap[localeKey]?.id || 'enUS';
			}
			this.setState({ language, market });
		}

		if (JSON.stringify(this.state.toogles) !== JSON.stringify(updatedFlags) || Object.keys(this.state.ssrFlags).length > 1) {
			// TODO: refactor this implementation to disconnect context and toggles/flags
			const toggles = Object.keys(this.state.ssrFlags).length ? this.state.ssrFlags : updatedFlags;
			this.updateToogles({ ...toggles });

			const { custom = [] } = this.state.filterOptionsDictionary || {};
			const uniqueDestinationsAvailable = custom?.options.map((value) => value.code);
			enableEmailOnTargetedOffers = toggles.enableEmailOnTargetedOffers;
			const defaultSorting = this.getDefaultSorting(toggles);
			this.setState({
				uniqueDestinationsAvailable,
				defaultSorting,
			});

			if (query && !this.state.uniqueDestinations.length) {
				this.updatedUniqueDestinations(updatedFlags);
			}
		}

		const fetchNewMarketPromo = marketChanged;
		if (this.state.toogles.showPromotionBanner && fetchNewMarketPromo) {
			this.fetchBestPromoForMarket(this.state.toogles?.showTargetedOffersPerksQualifier);
		}

		if (updatedFlags?.enableTargetedOffersFeature && updatedFlags?.showMyOffers) {
			const {
				resultsValidated,
				targetedOffersLoaded,
				targetedOffers,
				targetedOfferBannerSoldOut,
				targetedOfferApplied,
				targetedOfferIsValidPromo,
				targetedofferUrlValidateMatch,
			} = this.state;
			const targetedOfferAppliedNumKeys = Object.keys(targetedOfferApplied);
			if (resultsValidated && !!targetedOffersLoaded && !!targetedOffers?.length && targetedofferUrlValidateMatch) {
				if (targetedOfferBannerSoldOut) {
					if (targetedOfferAppliedNumKeys.length) {
						this.removeTargetedOfferApplied();
					} else {
						if (!targetedOfferIsValidPromo) {
							this.setState({
								targetedOfferBannerSoldOut: false,
							});
						}
					}
				}
			}

			if (!query[LOYALTY_ID.urlParam] && !enableEmailOnTargetedOffers && query[EMAIL_ID.urlParam]) {
				if (this.state.targetedOffersLoaded && !this.state.targetedOffersLoading) {
					this.applyFilters();
				}
			}

			if (
				this.state.targetedOfferApplied.couponCode &&
				(!prevState.targetedOfferApplied.couponCode || this.state.targetedOfferApplied.code !== prevState.targetedOfferApplied.code)
			) {
				const timeStamp = new Date();
				this.setState({
					lastTOActive: {
						couponCode: this.state.targetedOfferApplied.couponCode,
						timeStamp,
					},
				});
				localStorage.setItem(
					TARGETED_OFFER_APPLIED.key,
					JSON.stringify({
						promoCode: this.state.targetedOfferApplied.couponCode,
						code: this.state.targetedOfferApplied.code,
						lastApplied: timeStamp,
						status: TARGETED_OFFER_APPLIED.status_active,
					}),
				);
			}

			if (!this.state.targetedOfferApplied.couponCode && prevState.targetedOfferApplied.couponCode) {
				localStorage.setItem(
					TARGETED_OFFER_APPLIED.key,
					JSON.stringify({
						promoCode: this.state.lastTOActive.couponCode,
						lastApplied: this.state.lastTOActive.timeStamp,
						status: TARGETED_OFFER_APPLIED.status_removed,
					}),
				);
			}
		}

		if (query[SEARCH]?.includes(ADULTS) || query[SEARCH]?.includes(CHILDREN)) {
			const searchFilters = query[SEARCH]?.split(QUERY_PARAM_DIVIDER);
			const occupancyAdults = searchFilters?.filter((e) => e.includes(ADULTS)).toString();
			const occupancyChildren = searchFilters?.filter((e) => e.includes(CHILDREN)).toString();
			const isDefaultOption = occupancyAdults.includes(ADULTS_DEFAULT) && (occupancyChildren.includes(CHILDREN_DEFAULT) || occupancyChildren === '');

			const storeNumberOfGuests = localStorage.getItem(NUMBER_OF_GUESTS.key);

			if (!isDefaultOption) {
				localStorage.setItem(
					NUMBER_OF_GUESTS.key,
					JSON.stringify({
						adults: occupancyAdults,
						children: occupancyChildren,
					}),
				);
			} else if (isDefaultOption && storeNumberOfGuests) {
				localStorage.removeItem(NUMBER_OF_GUESTS.key);
			}
		}

		let portCodes = this.state.portCodes;

		if (Object.keys(labels).length > 0 && this.state.portCodes.length === 0) {
			portCodes = getPortCodes(labels);
			this.setState({
				portCodes: portCodes,
			});
		}
		if (this.state.results?.cruises?.length && !this.state.portAdded && Object.keys(portCodes).length > 0) {
			let newResults = { ...this.state.results };

			newResults.cruises = newResults?.cruises.reduce((res, cruise) => {
				if (cruise?.masterSailing?.itinerary && !cruise.masterSailing.itinerary.ports) {
					cruise.masterSailing.itinerary.ports = getPorts(cruise.masterSailing.itinerary.days, portCodes);
				}

				res.push(cruise);

				return res;
			}, []);
			newResults.total = this.calculateTotalCruises(newResults);

			this.setState({
				portAdded: true,
				results: newResults,
			});
		}

		if (
			prevState.targetedOfferApplied?.campaignId !== this.state.targetedOfferApplied?.campaignId ||
			(!this.state.targetedOfferApplied?.campaignId && this.state.targetedOffers !== prevState.targetedOffers)
		) {
			const targetedOffersSorted = sortTargetedOffers(this.state.targetedOffers, this.state.targetedOfferApplied);
			this.setState({ targetedOffersSorted });
		}

		if (
			this.state.toogles.showPromotionBanner &&
			this.state.toogles.showTargetedOffersPerksQualifiers !== prevState.toogles.showTargetedOffersPerksQualifiers
		) {
			this.fetchBestPromoForMarket(this.state.toogles?.showTargetedOffersPerksQualifiers);
		}
	}

	nlsIsFinished() {
		return !this.props.flags.enableNaturalLanguageSearch || !this.state.nlsValue || (this.state.nlsValue && this.state.nlsPerformed);
	}

	udpateSelectedCurrency = (currency) => {
		const { promotionsApplied = {}, toogles = {} } = this.state;
		const { code, valid } = promotionsApplied;
		const { showTargetedOffersPerksQualifiers } = toogles;

		this.setState(
			(prevState) => ({ locale: { ...prevState.locale, currency } }),
			() => {
				(async () => {
					if (valid) {
						this.getStatePromotions({ displayQualifier: showTargetedOffersPerksQualifiers, promo: code }, async () => {
							await this.fetchBestPromoForMarket(this.state.toogles?.showTargetedOffersPerksQualifiers);
						});
					} else {
						await this.fetchBestPromoForMarket(this.state.toogles?.showTargetedOffersPerksQualifiers);
					}
				})();
			},
		);
	};

	updateDataPromotions = (promoToSet, promotions, query) => {
		const { router = {}, initialState } = this.props;
		const { promo } = router.query;
		const uniqueDestinations = this.state.filterOptionsDictionary?.custom?.options || [];

		this.setPromotionsApplied(promotions);
		this.setPromotionApplied(promoToSet, () => {
			if (uniqueDestinations.filter((item) => includes(item.value, promo))?.length) {
				this.updatedUniqueDestinations();
			} else {
				const promoQuery = `${PROMO}=${promo}`;
				this.updateAdditionalFilters(promoQuery, () => this.updateOtherParamsString(query, promoQuery));
			}
			this.fetchSearchResults(
				query,
				true,
				{},
				{
					enableDefaultSortOption: initialState.ssrFlags[SERVER_TOGGLES.ENABLE_DEFAULT_SORT_OPTION],
					enableRecommendedSortOption: initialState.ssrFlags[SERVER_TOGGLES.ENABLE_RECOMMENDED_SORT_OPTION],
					enableRiverCruises: initialState.ssrFlags[SERVER_TOGGLES.ENABLE_RIVER_CRUISES],
				},
			);
		});
	};

	setPromotions = (promotions) => {
		this.setState((prevState) => {
			return {
				promotions: promotions || prevState.promotionsApplied,
			};
		});
	};

	setPromotionsApplied = (promotions, callback) => {
		this.setState({ promotionsApplied: promotions }, () => {
			if (callback) {
				const { query = {} } = this.props.router || {};
				const { querySearch: newQuerySearch } = this.getQueryUpdated(query);
				const { querySearch } = this.state;
				if (querySearch !== newQuerySearch) {
					callback();
				}
			}
		});
	};

	updateAdditionalFilters = (params, callback) => {
		this.setState(
			{
				additionalParamsApplied: params,
			},
			() => {
				if (callback) callback();
			},
		);
	};

	setPromotionSelected = (promotion) => {
		this.setState({ promotionSelected: promotion });
	};
	setPromotionApplied = (promotion, callback) => {
		if (promotion === null) {
			this.setState({ promotions: { valid: false }, promotionsApplied: {} });
		}

		const { toogles } = this.state;
		this.setState({ promotionApplied: promotion }, () => {
			if (callback) callback(toogles);
		});
	};

	getStatePromotions = async ({ displayQualifier, promo }, callback) => {
		const { apolloClient } = this.props;

		if (!promo) return;

		const { locale = {} } = this.state;
		const { currency } = locale;

		this.setState({ loadingPromotions: true });

		const promotions = await getPromotionsState({ apolloClient, promo, displayQualifier, currency });
		const { valid } = promotions;

		if (!valid) {
			this.setState(
				(prevState) => {
					return {
						promotions,
						loadingPromotions: false,
					};
				},
				() => {
					if (callback) {
						this.setPromotionSelected(null);
						this.updateAdditionalFilters(null, this.applyFilters);
					}
				},
			);
			return;
		}

		this.setState(
			{
				promotions,
				loadingPromotions: false,
			},
			() => {
				const { toogles } = this.state;
				if (callback) {
					callback(promo, promotions, toogles);
				}
			},
		);
	};

	validatePromotion = (prevState, updatedFlags) => {
		const { promotions, loadingPromotions, promotionApplied, promotionSelected, promotionsApplied } = this.state;

		if (!loadingPromotions && promotionSelected && promotionApplied && promotionSelected === promotionApplied) {
			const { query = {} } = this.props.router || {};
			const promotionsAreEqual = JSON.stringify(promotions) === JSON.stringify(promotionsApplied);

			if (!promotionsAreEqual) {
				if (promotions?.code === promotionApplied) {
					this.setPromotionsApplied(promotions, () => this.fetchSearchResults(query, true, prevState, updatedFlags));
				} else {
					this.setPromotions();
				}
			} else if (promotionsAreEqual && !promotions.valid) {
				this.resetAllFilters();
			}
		}
	};

	addOccupancyFromStorage = (occupancyLocalStorage, queryString) => {
		const storeAdults = JSON.parse(occupancyLocalStorage)?.adults;
		const storeChildren = JSON.parse(occupancyLocalStorage)?.children;
		const isDefaultOption = storeAdults.includes(ADULTS_DEFAULT) && (storeChildren.includes(CHILDREN_DEFAULT) || storeChildren === '');
		let occupancyFromStorage = '';

		if (!isDefaultOption) {
			occupancyFromStorage = [queryString[SEARCH], storeAdults, storeChildren].join(QUERY_PARAM_DIVIDER);
		} else {
			occupancyFromStorage = queryString[SEARCH];
		}

		return occupancyFromStorage;
	};

	removeAppliedPromotion = () => {
		const { router = {} } = this.props;
		const { promotions = {} } = this.state;
		const { valid } = promotions;
		if (!valid) {
			return;
		}
		this.setState(
			{
				promotions: {
					valid: false,
				},
			},
			() => {
				const queryString = this.state.queryStringParsed;

				const searchParams = new URLSearchParams(queryString);
				searchParams.delete(PROMO);
				searchParams.delete('search');
				const url = {
					query: decodeURIComponent(searchParams.toString()),
				};
				router.push(url, undefined, { shallow: true }).catch((error) =>
					// eslint-disable-next-line no-console
					console.log('Error router.push', error),
				);
			},
		);
	};

	getStateGlobalization(dictionaries) {
		return {
			globalization: {
				...this.getDictionaries(dictionaries),
			},
		};
	}

	getStateNaturalLanguage() {
		return {
			naturalLanguage: {
				valueSearch: '',
				instance: true,
				setValueSearch: (value) => {
					const naturalLanguage = {
						valueSearch: value,
					};
					this.setState({ naturalLanguage });
				},
				setInstance: (instance) => {
					const naturalLanguage = {
						...this.state.naturalLanguage,
						instance,
					};
					this.setState({ naturalLanguage });
				},
			},
		};
	}

	getDictionaries = (dictionaries) => {
		const { cruiseSearchDictionary, bookingDictionary } = dictionaries || {};
		const listDictionaries = filterDictionary({ ...cruiseSearchDictionary, ...bookingDictionary });
		const { pricingPanelDictionary } = listDictionaries;

		const { cabinClassDictionary, cabinClassOptions } = getCabinDictionary(pricingPanelDictionary, this.props.initialState.brand);

		return {
			dictionaries: {
				...listDictionaries,
				cabinClassOptions,
				cabinClassDictionary,
			},
		};
	};

	updateInitialTrackPageEvent = (initialTrackPageEvent) => {
		this.setState({ initialTrackPageEvent });
	};

	calculateTotalCruises = (newResults) => {
		const total =
			newResults.cruises.length <= count * (this.state.pagination.currentPage + 1) && newResults.total <= count
				? newResults.cruises.length
				: newResults.total;

		return total;
	};

	updateToogles = (toggles) => {
		this.setState({
			toogles: toggles,
			ssrFlags: {},
		});
	};

	sortCruisesBySortSelection = (cruises, sortVariable) => {
		let { by = null, order = null } = sortVariable || {};
		if (by === SORT_BY_PRICE || by === null) {
			if (order === SORT_ORDER_ASC || order === null)
				cruises.sort(
					(firstCruise, secondCruise) =>
						firstCruise?.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value -
						secondCruise?.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value,
				);
			else
				cruises.sort(
					(firstCruise, secondCruise) =>
						secondCruise?.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value -
						firstCruise?.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value,
				);
		}
		return cruises;
	};

	fetchSearchResults = async (query = {}, filterChange = false, prevState = {}, flags = {}) => {
		const { apolloClient } = this.props;
		const defaultSorting = this.getDefaultSorting(flags);

		const pagination = {
			count,
			skip: 0,
		};

		this.setState({
			resultsValidated: false,
			loading: true,
			pagination: {
				...pagination,
				currentPage: 0,
			},
			results: blankResults,
			imagePool: { itineraryImages: [], displayedImages: [] },
			filterChange,
		});

		const sortVariable = makeSortVariable(query[SORT], defaultSorting);

		const { enableRiverCruises, enableSendingLoyaltyidInCruiseSearchQuery: sendLoyalty } = flags;

		const { querySearch, isEmpty } = this.getQueryUpdated(query);

		const { data, error } = !isEmpty
			? await getFilterResults(apolloClient, {
					filters: querySearch,
					sort: sortVariable,
					qualifiers: parseQualifiers(query, sendLoyalty),
					pagination,
					nlSearch: query[NLS_PARAM],
					currency: this.state.locale?.currency,
					enableRiverCruises,
				})
			: {};

		if (error) {
			// Capture, Handle
			console.error(error); // eslint-disable-line no-console
			// this.setState({ loading: false });
			return;
		}

		let results = data?.cruiseSearch?.results || blankResults;
		results = {
			...results,
			cruises: this.sortCruisesBySortSelection(this.sortSailingsResults(results?.cruises), sortVariable),
			openSearch: Object.keys(query).length === 0,
			noResults: results?.total === 0,
		};
		this.validateRecallFetchResults(results?.total, prevState);

		const dispatchResultsReadyEvent = () => {
			setTimeout(
				dispatchCustomEvent(
					EVENT_SEARCH_RESULTS_READY,
					results?.cruises?.map((cruise) => cruise.id),
				),
			);
		};

		const nlFilters = results?.nlFilters;
		let nlParams = null;

		if (nlFilters && results?.total > 0) {
			const parsedParams = parseParamValue(nlFilters);
			Object.keys(parsedParams).forEach((key) => {
				if (!Array.isArray(parsedParams[key])) parsedParams[key] = [parsedParams[key]];
			});
			nlParams = getParamFromNL(parsedParams, this.state.searchSelecting, this.props.flags.enableNaturalLanguageSearch);
		}

		this.setState(
			{
				results,
				loading: false,
				portAdded: false,
				metadata: {
					...getMetadataValues(
						{
							search: this.state.searchApplied,
							sort: this.state.sortApplied,
							qualifiers: this.state.qualifiersApplied,
						},
						'',
						this.state.filterOptionsDictionary,
						this.getCompletePathname(this.props.router),
						this.props.config,
						this.state.locale,
						this.props.initialState.dictionaries.cruiseSearchDictionary,
					),
					image: getMetadataImage(results.cruises, this.props.config),
				},
				currentNls: nlParams,
				nlsInput: '',
			},
			dispatchResultsReadyEvent,
		);
	};

	updateFilterChange = (filterChange) => {
		this.setState({ filterChange });
	};

	updateStatusQueryChange = () => {
		this.setState({
			queryChanged: false,
		});
	};

	getQueryUpdated = (query) => {
		const { promotions = {}, searchSelecting, promotionApplied } = this.state;
		const { querySearch, isEmpty } = mergeQuerys({
			promotions,
			searchSelecting,
			querySearch: query[SEARCH],
			promotionApplied,
		});
		this.setState({
			querySearch,
		});
		return {
			querySearch,
			isEmpty,
		};
	};

	getPagination = () => {
		const { pagination } = this.state || {};
		const { currentPage = 0 } = pagination || {};
		return {
			count,
			skip: (currentPage + 1) * count || 0,
		};
	};

	fetchMoreSearchResults = async (callback) => {
		const { apolloClient } = this.props;
		const { query = {} } = this.props.router || {};
		const defaultSorting = this.getDefaultSorting(this.state.toogles);

		const pagination = this.getPagination();

		this.setState({
			loading: true,
			pagination: {
				...pagination,
				currentPage: Math.ceil(pagination.skip / count),
			},
			filterChange: false,
		});

		const sortVariable = makeSortVariable(query[SORT], defaultSorting);

		const sendLoyalty = +this.state.toogles?.enableSendingLoyaltyidInCruiseSearchQuery;

		const { querySearch } = this.getQueryUpdated(query);

		const { data, error } = await getFilterResults(apolloClient, {
			filters: querySearch,
			sort: sortVariable,
			qualifiers: parseQualifiers(query, sendLoyalty),
			pagination,
			nlSearch: query[NLS_PARAM],
			currency: this.state.locale?.currency,
			enableRiverCruises: this.state.toogles?.enableRiverCruises,
		});

		if (error) {
			// Capture, Handle
			console.error(error); // eslint-disable-line no-console
			// this.setState({ loading: false });
			return;
		}

		const results = data?.cruiseSearch?.results || blankResults;
		if (!results.total) return;

		const sortSailings = this.sortSailingsResults(results?.cruises);
		const dispatchResultsReadyEvent = () => {
			setTimeout(
				dispatchCustomEvent(
					EVENT_SEARCH_RESULTS_READY,
					results?.cruises?.map((cruise) => cruise.id),
				),
			);
		};

		this.setState((prevState) => {
			const prevCruises = prevState.results?.cruises || [];
			const newCruises = [...prevCruises, ...sortSailings];
			const newResults = {
				...prevState.results,
				cruises: this.sortCruisesBySortSelection(newCruises, sortVariable),
			};
			return {
				...prevState,
				results: newResults,
				loading: false,
				portAdded: false,
			};
		}, dispatchResultsReadyEvent);
		const { results: { total, cruiseRecommendationId } = {}, pagination: { currentPage, count: counter } = {} } = this.state;

		callback(total, currentPage, counter, cruiseRecommendationId);
	};

	fetchBestPromoForMarket = async (displayQualifier = true) => {
		const { apolloClient } = this.props;
		const { country, currency, language } = this.state.locale;

		const { data, error } = await getBestPromoForMarket(apolloClient, {
			country,
			currency,
			language,
			displayQualifier,
		});

		this.setState({ loadedPromo: true });

		if (error) {
			// Capture, Handle
			console.error(error); // eslint-disable-line no-console
			return;
		}

		const promo = data?.bestPromotionForMarket || {};
		this.setState({ promo });
	};

	getFavoritesList = async (user, isAuth) => {
		try {
			const { cruises } = await getUserFavorite(
				user,
				this.state.fullBrandSettings.nameOneWord,
				getFavoritesConfig(this.state.toogles, this.props.config),
				isAuth,
			);
			if (Array.isArray(cruises)) this.setState({ userFavorites: cruises });
		} catch (e) {
			return false;
		}
	};

	getWatchlistList = async (user, isAuth) => {
		const { endpoints } = this.props.config;
		const config = {
			api: endpoints.userWatchlistApi,
			link: '/watchlist',
		};

		if (isAuth && this.state.results.cruises.length > 0) {
			const { sailing_cabin_price_drop_triggers: sailings } = await getUserWatchlistItems(user, this.state.fullBrandSettings.nameOneWord, config);
			if (Array.isArray(sailings)) {
				this.setState({ userWatchlist: sailings });
				this.updateWatchlistResults('SELECTED', sailings);
			}
		}
		return this.state.userWatchlist;
	};

	fetchAndUpdateFacetOptions = async () => {
		const { apolloClient } = this.props;
		const { query = {} } = this.props.router || {};

		const queryParams = {
			[FACET]: makeRouteQueryFromStore({ [FACET]: this.state.searchSelecting }, this.state.filterOptions)?.substring(1),
			[QUALIFIERS]:
				makeRouteQueryFromStore({ [QUALIFIERS]: this.state.qualifiersSelecting }, this.state.filterOptions)?.split('=')[1] || query[QUALIFIERS],
		};
		const { data, error } = await getFacetOptions(apolloClient, {
			filters: queryParams[FACET],
			qualifiers: queryParams[QUALIFIERS],
			currency: this.state.locale?.currency,
		});

		if (error) {
			// Capture, Handle
			console.error(error); // eslint-disable-line no-console
			// this.setState({ loading: false });
			return;
		}

		const filterOptions = data?.cruiseSearch?.filters || [];
		const filterOptionsDictionary = keyBy(filterOptions, 'key');

		const facetsMap = Object.fromEntries(Object.entries(filterOptionsDictionary).map(([key, value]) => [key, value?.facets]));

		const facetOptions = (obj) => {
			const newObj = {};
			Object.keys(obj).forEach((key) => {
				const filter = obj[key];
				newObj[key] = {};
				if (filter?.length) {
					filter.forEach((subKey) => {
						const keyByCode = subKey?.code;
						newObj[key][keyByCode] = {
							code: subKey?.code,
							count: subKey?.count,
						};
					});
				}
			});
			return newObj;
		};

		const { promotions = {}, promotionSelected } = this.state;
		const { searchSelecting } = this.state;

		const newfacetOptions = mapFaceting({ promotions, facetOptions: facetOptions(facetsMap), promotionSelected, searchSelecting });
		this.setState((prevState) => {
			return {
				...prevState,
				facetOptions: newfacetOptions,
			};
		});
	};

	setIsInvalidEmailOrCASId = (value) => {
		this.setState({
			isInvalidEmailOrCASId: value,
		});
	};

	updateLoyaltyIDOrEmailLogin = (value) => {
		this.setState({
			loyaltyIDOrEmailLogin: value,
		});
	};

	getParamsToUrl = (query) => {
		const entries = Object.entries(query).map(([key, val]) => `${key}=${val}`) || [];
		const routeQuery = entries.join('&');
		return routeQuery;
	};

	getCompletePathname(router) {
		const { pathname } = router;
		const { market } = router.query;

		if (market) {
			let path = pathname;
			path = path.replace(matchMarket, this.state.market);
			path = path.replace(matchLanguage, this.state.language);

			return path;
		}

		return pathname;
	}

	validateItineraryPanel = () => {
		const router = this.props.router;
		const pathnameFormated = this.getCompletePathname(router);
		const query = urlParamsToObject(this.state.queryStringParsed);
		const { itineraryPanel } = query || {};

		if (itineraryPanel) {
			delete router.query.itineraryPanel;
			this.setState(
				{
					itineraryPanel: '',
				},
				() => {
					this.applyFilters();
					router?.push(`${pathnameFormated}?${this.getParamsToUrl(router.query)}`, undefined, {
						shallow: true,
					});
				},
			);
		}
	};

	getModalByUrl = () => {
		if (this.state.modalByUrlOpen) return undefined;

		const query = urlParamsToObject(this.state.queryStringParsed);

		const modals = {
			myoffers: 'qualifiers',
		};
		const { popup } = query || {};
		return popup ? modals[popup] : undefined;
	};

	openModalByUrl = () => {
		if (this.state.modalByUrlOpen) return;
		const modalTarget = this.getModalByUrl();
		if (modalTarget) {
			this.validateItineraryPanel();
			this.openFilters(modalTarget, 'singleFilter');
			this.setState({
				modalByUrlOpen: true,
			});
		}
	};

	updateNls = (performed) => {
		this.setState((prevState) => {
			return {
				...prevState,
				nlsPerformed: performed,
			};
		});
	};

	updateCurrentNls = (params) => {
		this.setState((prevState) => {
			return {
				...prevState,
				currentNls: params,
			};
		});
	};

	updateNlsInput = (value) => {
		this.setState((prevState) => {
			return {
				...prevState,
				nlsInput: value,
			};
		});
	};

	setOtherParamsString = (query, params) => {
		const analyticsParams = params?.split('&') || [];
		const keysAnalytics = analyticsParams?.map((param) => param.split('=')[0]) || [];

		const otherParams = Object.keys(query).map((key) => {
			if (![SEARCH, SORT, QUALIFIERS, FACET, GROUP_ID, ANALYTICS, POPUP, NLS_PARAM, ...keysAnalytics].includes(key)) {
				return `${key}=${query[key]}`;
			}
		});

		return otherParams;
	};

	updateOtherParamsString = (query, params, callback) => {
		const otherParams = this.setOtherParamsString(query, params);

		this.setState(
			{
				otherParamsApplied: otherParams?.filter(Boolean).join('&'),
			},
			() => {
				if (callback) callback();
			},
		);
	};

	updateStoreFromQuery = (query, flags, callback) => {
		let { search, sort, qualifiers, q } = makeStoreFromRouteQuery(query);
		const queryParamsToObject = query[SEARCH]?.includes(MULTI_QUERY_PARAM_DIVIDER) ? makeParamsObjectFromRouteQuery(query) : {};

		if (Object.keys(search).length === 0) {
			search = searchDefault;
		}

		this.setState(
			(prevState) => {
				const otherParams = this.setOtherParamsString(query, prevState?.additionalParamsApplied);

				return {
					searchApplied: search,
					searchSelecting: search,
					sortApplied: sort.length ? sort : this.state.sortApplied,
					qualifiersApplied: qualifiers,
					qualifiersSelecting: qualifiers,
					targetedOfferApplied: prevState.targetedOfferSelected,
					monthsApplied: prevState.monthsSelecting,
					datesApplied: prevState.datesSelecting,
					nlsValue: q,
					queryParamsObject: queryParamsToObject,
					queryParamsObjectApplied: queryParamsToObject,
					otherParamsApplied: otherParams?.filter(Boolean).join('&'),
				};
			},
			() => {
				if (callback) callback();
			},
		);
	};

	updatedUniqueDestinations = () => {
		const { query = {} } = this.props.router || {};
		const { search, ...others } = query;
		const { uniqueDestinations, additionalParamsApplied, promotionApplied } = this.state;

		const customFiltersOptions = this.state.filterOptionsDictionary?.custom?.options;
		const data = { customFiltersOptions, search, others, promotionApplied, additionalParamsApplied };
		const { destinations, paramsAnalytics } = updatedUniqueDestinationsUtil(data);
		const isUniqueDestinationChanged =
			JSON.stringify(uniqueDestinations) !== JSON.stringify(destinations) || additionalParamsApplied !== paramsAnalytics;

		if (isUniqueDestinationChanged) {
			this.updateOtherParamsString(query, paramsAnalytics);
			this.setState({
				uniqueDestinations: [...destinations],
				additionalParamsApplied: paramsAnalytics,
			});
		}
	};

	updateSearchSelectingFilter = (filterName, value, callback) => {
		const { query = {} } = this.props.router || {};
		let queryParamsToObject = _cloneDeep(this.state.queryParamsObject);

		const { search } = query;

		if (Object.keys(queryParamsToObject || {})?.length) {
			if (value?.length) {
				const itemsQuery = queryParamsToObject?.[SEARCH]?.[filterName] ?? [];
				const groupFilters = itemsQuery.flatMap((item) => item).flatMap((item) => item.split(','));
				const values = value.flatMap((item) => item).flatMap((item) => item?.split(','));
				let valueToAdd = [];

				if (values?.length < groupFilters?.length) groupFilters?.forEach((filter) => !values?.includes(filter) && valueToAdd.push(filter));
				else values?.forEach((filter) => !groupFilters?.includes(filter) && valueToAdd.push(filter));

				valueToAdd = valueToAdd.slice(-1)?.[0];
				queryParamsToObject = addFilterQueryParamsObject(valueToAdd, filterName, search, queryParamsToObject);
			}
		}

		this.setState(
			(prevState) => ({
				...prevState,
				searchSelecting: { ...prevState.searchSelecting, [filterName]: value },
				nlUserQuery: '',
				nlsValue: '',
				queryParamsObject: queryParamsToObject,
			}),
			callback,
		);
	};

	updateMonthsSelectingFilter = (filterName, value) => {
		this.setState((prevState) => {
			return {
				...prevState,
				monthsSelecting: { ...prevState.monthsSelecting, [filterName]: value },
			};
		});
	};

	updateDatesSelectingFilter = (filterName, value) => {
		this.setState((prevState) => {
			return {
				...prevState,
				datesSelecting: { ...prevState.datesSelecting, [filterName]: value },
			};
		});
	};

	updateSearchSelecting = (nlUserQuery, searchSelecting, callback) => {
		this.setState(
			(prevState) => ({
				...prevState,
				nlUserQuery,
				searchSelecting,
			}),
			callback,
		);
	};

	addToSearchSelectingFilter = (filterName, valueToAdd, callback, uniqueDestination = null) => {
		const { query = {} } = this.props.router || {};
		const isUniqueDestination = validateIsUniqueDestination(this.state.uniqueDestinationsAvailable, uniqueDestination?.filterName);

		this.setState((prevState) => {
			let queryParamsToObject = prevState.queryParamsObject;
			const { search } = query;
			if (Object.keys(queryParamsToObject || {})?.length && !Object.keys(uniqueDestination || {})?.length) {
				queryParamsToObject = addFilterQueryParamsObject(valueToAdd, filterName, search, queryParamsToObject);
			} else {
				queryParamsToObject = {};
			}

			const prevFilters = prevState.searchSelecting[filterName] || [];
			const nextFilters = [...new Set([...prevFilters, valueToAdd])];

			const uniqueFilters = isUniqueDestination ? getUniqueDestinationAndParamsUtil(uniqueDestination, prevState.uniqueDestinations) : {};
			const prevSearchSelecting = { ...prevState.searchSelecting };

			return {
				...prevState,
				searchSelecting: {
					...prevSearchSelecting,
					[filterName]: nextFilters,
				},
				nlUserQuery: '',
				...uniqueFilters,
				queryParamsObject: queryParamsToObject,
			};
		}, callback);
	};

	removeAdditionalFilters = () => {
		this.setState({
			additionalParamsApplied: null,
		});
	};

	removeFromSearchSelectingFilter = (filterName, valueToRemove, callback, uniqueDestination = null, isPromo = false) => {
		const { custom = {} } = this.state.filterOptionsDictionary || [];
		const isUniqueDestination = validateIsUniqueDestination(custom?.options, uniqueDestination);

		this.setState((prevState) => {
			let queryParamsToObject = _cloneDeep(prevState.queryParamsObject);

			if (Object.keys(queryParamsToObject || {})?.length && !uniqueDestination?.paramValue) {
				queryParamsToObject = removeFilterQueryParamsObject(valueToRemove, filterName, queryParamsToObject);
			}

			const nextFilters = prevState.searchSelecting?.[filterName]?.filter((item) => item !== valueToRemove);

			const listUniqueDestinations = Array.isArray(prevState.uniqueDestinations) ? prevState.uniqueDestinations : [];

			const nextUniqueDestinationsFilters = isUniqueDestination
				? listUniqueDestinations.filter((d) => !d[uniqueDestination] === filterName)
				: prevState.uniqueDestinations;

			const dataPromotions = (isUniqueDestination && isPromo && { promotionApplied: null, promotionSelected: null }) || {};

			return {
				...prevState,
				searchSelecting: {
					...prevState.searchSelecting,
					[filterName]: nextFilters,
				},
				nlUserQuery: '',
				uniqueDestinations: nextUniqueDestinationsFilters,
				additionalParamsApplied: isUniqueDestination ? null : prevState.additionalParamsApplied,
				queryParamsObject: queryParamsToObject,
				...dataPromotions,
			};
		}, callback);
	};

	removeQualifierApplied = () => {
		if (this.state.qualifiersSelecting.some((item) => item.includes(COUPON))) {
			this.removeAllFilters();
		}
	};

	resetSearchSelecting = (callback) => {
		this.setState(
			{
				searchSelecting: {},
			},
			callback,
		);
	};

	resetSearchSelectingToSearchApplied = (callback) => {
		this.setState(
			{
				searchSelecting: this.state.searchApplied,
				qualifiersSelecting: this.state.qualifiersApplied,
				targetedOfferSelected: this.state.targetedOfferApplied,
				monthsSelecting: {
					startDate: this.state.monthsApplied?.[START_DATE] || [],
				},
				datesSelecting: {
					startDate: this.state.datesApplied?.[START_DATE] || [],
				},
			},
			callback,
		);
	};

	updateSortApplied = (sort, label, callback) => {
		this.setState({ sortApplied: sort }, () => {
			this.applyFilters();
			if (callback) {
				callback(label);
			}
		});
	};

	updateQualifiersSelecting = (qualifiersSelecting, callback) => {
		this.setState(
			(prevState) => ({
				...prevState,
				qualifiersSelecting,
			}),
			callback,
		);
	};

	addToQualifiersSelecting = (valueToAdd, isPromo, callback) => {
		this.removeAllFilters();

		this.setState((prevState) => {
			const listQualifiersSelecting = Array.isArray(prevState.qualifiersSelecting) ? prevState.qualifiersSelecting : [];
			const prevQualifiersApplied = isPromo ? listQualifiersSelecting.filter((item) => !includes(item, COUPON)) : prevState.qualifiersSelecting;

			const prevQualifiers = prevQualifiersApplied || [];
			const qualifiersSelecting = [...prevQualifiers, valueToAdd];
			return {
				...prevState,
				qualifiersSelecting,
			};
		}, callback);
	};

	removeParamFromOtherParams = (valueToRemove) => {
		this.setState((prevState) => {
			const otherParamsApplied = prevState.otherParamsApplied.split('&');

			const otherParamsToApply = otherParamsApplied?.filter((item) => item !== valueToRemove);

			return {
				...prevState,
				otherParamsApplied: otherParamsToApply?.filter(Boolean).join('&'),
			};
		});
	};

	removeFromQualifiersSelecting = (valueToRemove, callback) => {
		this.setState((prevState) => {
			const qualifiersSelecting = prevState.qualifiersSelecting?.filter((item) => item !== valueToRemove);
			return {
				...prevState,
				qualifiersSelecting,
			};
		}, callback);
	};

	resetSearchSelectingFilter = (filter, callback) => {
		const params = this.state.queryParamsObject;
		const { [SEARCH]: restSearch, ...restParamsObject } = params;
		const newRestSearch = { ...restSearch };
		delete newRestSearch[filter];
		const searchFilters = newRestSearch;
		const restQueryParamsObject = searchFilters?.length ? { [SEARCH]: searchFilters, ...restParamsObject } : { ...restParamsObject };

		this.setState(
			(prevState) => ({
				...prevState,
				searchSelecting: { ...prevState.searchSelecting, [filter]: [] },
				queryParamsObject: restQueryParamsObject,
			}),
			callback,
		);
	};

	getUniqueDestinationsState = (container, promotion = null) => {
		const { query = {} } = this.props.router || {};
		const { search } = query;
		const { additionalParamsApplied, searchSelecting, monthsSelecting } = this.state;
		const others = getObjectFromQuery(additionalParamsApplied, '&', '=');

		const selectingFilters = Object.entries({ ...searchSelecting, ...monthsSelecting })
			.filter(([_, value]) => value)
			.map(([key, value]) => `${key}:${value.join(',')}`)
			.join(QUERY_PARAM_DIVIDER);

		const customFiltersOptions = this.state.filterOptionsDictionary?.custom?.options;
		const data = { customFiltersOptions, container, selectingFilters, others, search, promotion };
		const specialFilters = getUniqueDestinationsStateUtil(data);

		return specialFilters;
	};

	resetAllFilters = () => {
		this.setState(
			(prevState) => {
				return {
					...prevState,
					searchSelecting: null,
					nlUserQuery: '',
					qualifiersSelecting: null,
					uniqueDestinations: [],
					additionalParamsApplied: null,
					monthsSelecting: {},
					datesSelecting: {},
					promotionApplied: null,
					promotionSelected: null,
					promotions: {
						valid: false,
					},
					promotionsApplied: {},
				};
			},
			() => {
				dispatchCustomEvent(EVENT_CLEAN_WIDGET_FILTERS);
				this.applyFilters();
				const storeNumberOfGuests = localStorage.getItem(NUMBER_OF_GUESTS.key);

				if (storeNumberOfGuests) {
					localStorage.removeItem(NUMBER_OF_GUESTS.key);
				}
			},
		);
	};

	removeAllFilters = () => {
		this.setState((prevState) => {
			return {
				...prevState,
				searchSelecting: {},
				qualifiersSelecting: [],
				monthsSelecting: {},
				datesSelecting: {},
				queryParamsObject: {},
				additionalParamsApplied: null,
			};
		});
	};

	removeTargetedOfferApplied = () => {
		this.setState((prevState) => {
			return {
				...prevState,
				targetedOfferApplied: {},
				targetedOfferSelected: {},
				targetedOffersDisabledMessage: {},
			};
		});
	};

	getState = () => {
		return this.state;
	};

	updateState = (state, callback) => {
		if (callback) {
			this.setState((prevState) => {
				return {
					...prevState,
					...state,
				};
			}, callback);
		} else {
			this.setState((prevState) => {
				return {
					...prevState,
					...state,
				};
			});
		}
	};

	getOtherParams = (union, removeHomePageQueryParam) => {
		if (!this.state.otherParamsApplied) {
			return '';
		}

		const searchParams = new URLSearchParams(this.state.otherParamsApplied);
		if (removeHomePageQueryParam) searchParams.delete(HOME_PAGE_QUERY_PARAM);

		const { query = {} } = this.props.router;
		const { promo } = query;

		if (promo) {
			const { promotions = {} } = this.state;
			const { valid } = promotions;
			if (!valid) {
				searchParams.delete('promo');
			}
		}

		const otherParamsString = decodeURIComponent(searchParams.toString());
		return otherParamsString ? `${union}${otherParamsString}` : '';
	};

	applyFilters = (configOptions = {}) => {
		const { scroll = true, removeHomePageQueryParam = false } = configOptions;
		if (scroll) {
			dispatchCustomEvent(EVENT_CRUISE_SEARCH_APPLY_FILTERS);
		}
		const { router } = this.props;
		const queryParams = {
			[SEARCH]: this.state.searchSelecting,
			[SORT]: this.state.sortApplied,
			[QUALIFIERS]: this.state.qualifiersSelecting,
			[GROUP_ID]: this.state.itineraryPanel,
			[ANALYTICS]: this.state.additionalParamsApplied,
			...(this.props.flags.enableGraphNlSearch && { [NLS_PARAM]: this.state.nlUserQuery }),
		};

		const routeQuery = makeRouteQueryFromStore(queryParams, this.state.filterOptions, this.state.queryParamsObject);

		const union = !routeQuery.length ? '?' : '&';

		const otherParams = this.getOtherParams(union, removeHomePageQueryParam);

		const { route } = this.props.router || {};
		let pathname = route;
		pathname = pathname.replace(matchMarket, this.state.market);
		pathname = pathname.replace(matchLanguage, this.state.language);
		const page = pathname?.split('/')?.pop();
		const urlPathName = `${this.state.locale?.path}${page === COMPARE_PAGE ? CRUISES_COMPARE_PAGE : page}`;

		router?.push(`${urlPathName}${routeQuery}${otherParams}`, undefined, {
			shallow: true,
		});
	};

	selectGroupIdDetail = (itineraryPanel) => {
		this.setState(
			{
				itineraryPanel,
			},
			() => {
				this.applyFilters({ scroll: false });
			},
		);
	};

	replaceSearchResultsCruises = (cruises, callback) => {
		const total = cruises?.length;
		if (!cruises || total <= 0) {
			this.resetSearchResults();
			return;
		}
		const results = {
			total,
			cruises,
			openSearch: false,
		};

		this.setState(
			{
				results,
				pagination: {
					count,
					skip: total,
					currentPage: Math.ceil(total / count),
				},
			},
			callback,
		);
	};

	resetSearchResults = (callback) => {
		this.setState({ results: blankResults, pagination: { count, skip: 0, currentPage: 0 } }, callback);
	};

	openFilters = (filterOpen, filterMode) => {
		this.fetchAndUpdateFacetOptions();
		this.setState({ filterOpen, filterMode });
	};

	clearModalParams = () => {
		const router = this.props.router;
		const query = router?.query;
		const { popup } = query || {};
		const pathnameFormated = this.getCompletePathname(router);

		if (popup) {
			delete router.query.popup;

			router?.push(`${pathnameFormated}?${this.getParamsToUrl(router.query)}`, undefined, {
				shallow: true,
			});
		}
	};

	closeFilters = () => {
		this.clearModalParams();
		// perform this inside function call or button click etc
		this.setState({ filterOpen: '', filterMode: '' });
	};

	resetQueryParamsObject = () => {
		this.setState((prevState) => {
			return { queryParamsObject: prevState.queryParamsObjectApplied };
		});
	};

	openModal = (modalOpen) => {
		this.setState({ modalOpen });
	};

	closeModal = () => {
		this.setState({ modalOpen: '' });
	};

	toogleLoader = () => {
		const { showLoading } = this.state;
		this.setState({ showLoading: !showLoading });
	};

	loadDictionary = async (dictionaryName) => {
		const { labels, locale } = this.state;

		if (labels[dictionaryName]) {
			return labels[dictionaryName];
		} else {
			const newLabels = await getDictionary(dictionaryName, locale.language, this.props.config);

			this.setState({
				labels: {
					...labels,
					[dictionaryName]: newLabels,
				},
			});

			return newLabels;
		}
	};

	sortSailingsResults = (cruises) => {
		const imagePool = getImagePool(cruises, this.state.imagePool);
		const { [CABIN_CLASS]: cabinClass } = this.state.searchApplied;
		this.setState({ imagePool });

		return cruises.map((cruise) => {
			const cruiseWithFeaturedImage = {
				...cruise,
				featuredImage: getFeaturedImage(imagePool, cruise),
				sailings: [...cruise.sailings],
			};

			return {
				...cruiseWithFeaturedImage,
				// PENDING: remove returning the two cruise formats
				cruise: reduceCruise(cruiseWithFeaturedImage, this.props.config, cabinClass),
			};
		});
	};

	getSailingsByCruise = async (id) => {
		const { apolloClient } = this.props;

		const { data, error } = await getSailingsByCruise(apolloClient, { id });

		return {
			data,
			error,
		};
	};

	getCountries = async () => {
		const { apolloClient } = this.props;
		const countries = (await getAllCountries(apolloClient)).data.allCountries || countryList;
		this.setState({
			countries: countries,
		});
		return countries;
	};

	updateWatchlistResults = (status, sailings) => {
		const { results } = this.state;

		const newCruises = results.cruises;

		sailings?.forEach((sailing) => {
			let cruiseIdx = 0;
			newCruises.forEach((cruise, i) => {
				const sailingIdx = cruise.sailings.findIndex((s) => {
					return s.id === sailing.sailing_id;
				});
				if (sailingIdx >= 0) cruiseIdx = i;
			});
			const cruise = updateCruiseStateroomClassPricing(newCruises[cruiseIdx], status, sailings);

			newCruises[cruiseIdx] = cruise;
		});

		this.setState({
			results: { ...results, cruises: newCruises },
		});
	};

	resetSoldOut = () => {
		this.setState({ targetedOfferBannerSoldOut: false });
	};

	validateRecallFetchResults = (totalResults, prevState) => {
		const promo = this.state.qualifiersApplied.find((qualifier) => includes(qualifier, COUPON));
		const prevPromo = prevState.qualifiersApplied?.find((qualifier) => includes(qualifier, COUPON));

		if (promo && !totalResults && promo !== prevPromo) {
			this.removeFromQualifiersSelecting(`${COUPON}:${promo?.split(':')[1]}`, this.applyFilters);
			this.removeTargetedOfferApplied();
			this.setState({
				targetedOfferBannerSoldOut: true,
				resultsValidated: true,
			});
		}

		if (totalResults) {
			this.setState({
				resultsValidated: true,
			});
		}
	};

	setAppliedDateFilter = (dateFilter) => {
		this.setState({
			appliedDateFilter: dateFilter,
		});
	};

	getDefaultSorting = (flags) => {
		const { enableDefaultSortOption, enableRecommendedSortOption } = flags;
		let defaultSorting;

		if (enableDefaultSortOption) {
			defaultSorting = SORT_OPTIONS.find((item) => item.gdp === enableDefaultSortOption)?.props;
		}

		if (!enableRecommendedSortOption && defaultSorting?.by === 'RECOMMENDED') {
			defaultSorting = undefined;
		}

		return defaultSorting;
	};

	render() {
		return <CruiseSearchContext.Provider value={this.state}>{this.props.children}</CruiseSearchContext.Provider>;
	}
}

CruiseSearchContextProvider.propTypes = {
	children: PropTypes.node,
	router: PropTypes.shape({
		pathname: PropTypes.string,
		asPath: PropTypes.string,
		route: PropTypes.string,
		query: PropTypes.shape({
			filters: PropTypes.string,
			search: PropTypes.string,
			language: PropTypes.string,
			market: PropTypes.string,
		}).isRequired,
		push: PropTypes.func.isRequired,
	}),
	apolloClient: PropTypes.object,
	config: PropTypes.object,
	initialState: PropTypes.shape({
		ssrFlags: PropTypes.object,
		brand: PropTypes.string,
	}),
	flags: PropTypes.object,
};

export default withRouter(withLDConsumer()(CruiseSearchContextProvider));
